import React from 'react';
import styled from 'styled-components';

import Imgix from 'shared/components/imgix';
import { OrderImage } from './get-unique-order-images';

const MAX_THUMBNAILS = 3;

type OrderThumbnailsProps = {
  images: OrderImage[];
};

export function OrderThumbnails({ images }: OrderThumbnailsProps): JSX.Element | null {
  const visible = images.slice(0, MAX_THUMBNAILS);
  const overflow = images.length - MAX_THUMBNAILS;

  if (visible.length === 0) {
    return null;
  }

  return (
    <>
      {visible.map(({ src, alt }) => (
        <Thumbnail key={src} src={src} htmlAttributes={{ alt }} />
      ))}
      {overflow > 0 && (
        <MoreBadge>
          <span>+{overflow}</span>
          <span>more</span>
        </MoreBadge>
      )}
    </>
  );
}

const Thumbnail = styled(Imgix)`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid ${({ theme }) => theme.colors.grey[90]};
`;

const MoreBadge = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.grey[95]};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.grey[30]};
`;
